import { render, staticRenderFns } from "./BtnDecoHover.vue?vue&type=template&id=508e985c&"
import script from "./BtnDecoHover.vue?vue&type=script&lang=js&"
export * from "./BtnDecoHover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports